import { render, staticRenderFns } from "./ReferenceBooks.vue?vue&type=template&id=000561ae&scoped=true&"
import script from "./ReferenceBooks.vue?vue&type=script&lang=js&"
export * from "./ReferenceBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000561ae",
  null
  
)

export default component.exports